import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M22.997 15.142a11 11 0 0 0-8.64-10.738v-.26a2.357 2.357 0 0 0-4.714 0v.26a11 11 0 0 0-8.64 10.738v2.443a1 1 0 0 0 0 .15v1.727a2.73 2.73 0 0 0 1.28 2.357 2.49 2.49 0 0 0 2.443.118A16.5 16.5 0 0 1 12 20.209c2.538.005 5.039.602 7.305 1.743a2.45 2.45 0 0 0 2.404-.117 2.78 2.78 0 0 0 1.288-2.357v-1.744a1 1 0 0 0 0-.149v-2.443m-1.57 0v1.131a18.4 18.4 0 0 0-3.04-1.5 9.43 9.43 0 0 0-.99-6.284 9.2 9.2 0 0 0-1.328-1.823 9.43 9.43 0 0 1 5.357 8.476M7.121 14.27A7.674 7.674 0 0 1 12 5.77a7.675 7.675 0 0 1 4.878 8.5A18.1 18.1 0 0 0 12 13.571c-1.65.003-3.293.238-4.878.7M12 3.36a.785.785 0 0 1 .786.785h-1.572A.786.786 0 0 1 12 3.359M7.931 6.65a9.2 9.2 0 0 0-1.327 1.823 9.43 9.43 0 0 0-.99 6.284c-1.057.41-2.075.914-3.04 1.508v-1.123A9.43 9.43 0 0 1 7.93 6.651m13.495 12.812a1.2 1.2 0 0 1-.55 1.037.87.87 0 0 1-.872.047A17.8 17.8 0 0 0 12 18.638c-2.764.01-5.49.655-7.965 1.885a.91.91 0 0 1-.927-.047 1.16 1.16 0 0 1-.534-1.014v-1.32a16.67 16.67 0 0 1 9.426-3 16.62 16.62 0 0 1 9.426 3z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.357 10.429a2.357 2.357 0 1 0-4.714 0 2.357 2.357 0 0 0 4.714 0m-3.142 0a.785.785 0 1 1 1.57 0 .785.785 0 0 1-1.57 0"
    }, null, -1)
  ]))]))
}
export default { render: render }